import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS } from "../data/content";

const Counter = ({ to, suffix = "+", duration = 1600 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    if (to === 0) {
      setValue(0);
      return;
    }
    let start = 0;
    const startTime = performance.now();
    const tick = (t) => {
      const progress = Math.min((t - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.floor(start + eased * (to - start)));
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, to, duration]);

  return (
    <span ref={ref}>
      {value}
      {suffix}
    </span>
  );
};

const StatsBar = () => {
  return (
    <section
      data-testid="stats-bar"
      className="relative bg-forest text-cream py-16 md:py-20 overflow-hidden"
    >
      <div className="grain" />
      <div className="container mx-auto px-6 md:px-10 xl:px-16 relative">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              className={`${
                i !== 0 ? "md:border-l md:border-cream/15 md:pl-8" : ""
              } flex flex-col`}
              data-testid={`stat-${i}`}
            >
              <span className="font-serif text-5xl md:text-6xl text-saffron leading-none">
                <Counter to={s.value} suffix={s.suffix} />
              </span>
              <span className="eyebrow mt-5 text-cream/70">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
